import React from 'react';
import PropTypes from 'prop-types';

import {
    BulkDeleteButton,
    BulkUpdateButton,
} from 'react-admin';

import { Permissions } from '@src/global/permissions';
import DownloadZipButton from './DownloadZipButton';

const BulkActionButtons = (props) => {
    const { resource, hasList, hasEdit, hasShow, hasCreate, syncWithLocation, ...rest } = props;

    let res = resource;
    if (res === 'admins' || res === 'employees' || res === 'agents') {
        res = 'users';
    }

    if (res === 'contact_forms' || res === 'holiday_gift_requests' || res === 'quote_inquiries') {
        res = 'form_entries';
    }

    const canDownloadZip = [
        'product_updates',
        'rate_bulletins',
        'underwriting_guidelines',
        'program_guides',
    ].includes(resource);

    const canDelete = !['platforms', 'all_products', 'products'].includes(resource) && Permissions(res, 'delete') === true;

    return (
        <>
            {canDownloadZip && Permissions(resource, 'update') === true ? <DownloadZipButton resource={resource} /> : null}
            {
                resource === 'agents' && Permissions('users', 'update') === true && (
                    <>
                        <BulkUpdateButton
                            label="Grant Premier Access"
                            icon={null}
                            basePath="/users"
                            data={{ premier_access: true }}
                        />
                        <BulkUpdateButton
                            label="Revoke Premier Access"
                            icon={null}
                            basePath="/users"
                            data={{ premier_access: false }}
                        />
                    </>
                )
            }
            {
                resource === 'agencies' && Permissions('users', 'update') === true && (
                    <>
                        <BulkUpdateButton
                            label="Grant Premier Access"
                            icon={null}
                            basePath="/agencies"
                            data={{ premier_access: true }}
                        />
                        <BulkUpdateButton
                            label="Revoke Premier Access"
                            icon={null}
                            basePath="/agencies"
                            data={{ premier_access: false }}
                        />
                    </>
                )
            }
            {canDelete ? <BulkDeleteButton {...rest} undoable={false} /> : null}
        </>
    );
};

BulkActionButtons.propTypes = {
    resource: PropTypes.string,
};

export default BulkActionButtons;
